import { atom } from 'jotai'

/**
 * 滑动导航状态
 * 用于记录用户的滑动后退手势,各模块可以根据这个状态决定是否执行后退操作
 */

// 滑动后退触发计数器
// 每次触发滑动后退手势时递增,模块可以监听此值的变化来决定是否执行后退
export const swipeBackTriggerAtom = atom<number>(0)

// 最后一次滑动的方向和距离信息(用于调试或更精细的控制)
export interface SwipeInfo {
  deltaX: number // 水平移动距离
  deltaY: number // 垂直移动距离
  timestamp: number // 触发时间戳
}

export const lastSwipeInfoAtom = atom<SwipeInfo | null>(null)
